import React from 'react';
import About from './components/About';
import Games from './components/Games'; // to be used later on ;D
import Header from './components/Header';
import './App.css';
import Footer from './components/Footer';

//remember to reactivate the games button on header

function App() {
  return (
    <div className="App">
      
      <Header />

      <main>
        <About />
        <Games />
      </main>

      <Footer />
    </div>
  );
}

export default App;
